import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import 'focus-visible'

const application = Application.start()
const context = require.context('./controllers', true, /_controller\.js$/)

application.load(definitionsFromContext(context))

// Trigger PDF download on successful holiday form submission
if (typeof window !== 'undefined') {
  document.addEventListener('freeform-success', function(e) {
    if (e.target && e.target.id === 'holiday-form') {
      window.open('/uploads/pdfs/Summer-Holidays-Information-Pack-final-1.pdf', '_blank');
    }
  }, false);
}
